import * as React from "react";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function Range({
  views,
  min,
  max,
  fromOnChange,
  toOnChange,
  from,
  to,
  fromError,
  toError,
  errors,
}) {
  function inHouseErrors(error, type = null) {
    if (errors) return error ? "Required" : null;
    if (type === "to") return toError;
    else return fromError;
  }
  const [minValue, setMinValue] = React.useState(min);
  
  // Validation function to check if toDate is before fromDate
  const isToDateBeforeFromDate = () => {
    if (from && to && to < from) {
      return true;
    }
    return false;
  };
  
  return (
    <LocalizationProvider LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="form-group d-flex gap-4 flex-wrap p-0">
        <DatePicker
          views={views}
          minDate={min}
          maxDate={max}
          label="From"
          value={from}
          inputFormat="dd/MM/yyyy"
          onChange={(params) => {
            setMinValue(params);
            fromOnChange(params);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!inHouseErrors(params.error, "from")}
              helperText={inHouseErrors(params.error, "from")}
            />
          )}
        />
        <DatePicker
          views={views}
          minDate={minValue}
          maxDate={max}
          label="To"
          value={to}
          inputFormat="dd/MM/yyyy"
          onChange={toOnChange}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!inHouseErrors(params.error, "to")}
              helperText={inHouseErrors(params.error, "to")}
            />
          )}
        />
      </div>
    </LocalizationProvider>
  );
}
